// 30-day volatility from price history; risk band classification.

export function computeVolatility(prices: number[]): { stdev: number; band: 'low'|'medium'|'high' } {
  if (prices.length === 0) return { stdev: 0, band: 'low' };
  const n = prices.length;
  const mean = prices.reduce((a,b)=>a+b,0)/n;
  const variance = prices.reduce((a,p)=> a + Math.pow(p-mean,2),0)/n;
  const stdev = Math.sqrt(variance);
  const normalized = mean>0 ? stdev/mean : 0;
  const band = normalized < 0.05 ? 'low' : normalized < 0.15 ? 'medium' : 'high';
  return { stdev: parseFloat(stdev.toFixed(2)), band };
}



















